import { omit } from "lodash";
import { apiSlice } from "../services/apiSlice";


export const membershipApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createNewMembership: builder.mutation({
            query: (data) => ({
                url: '/membership-types',
                method: 'POST',
                body: {
                    ...data,
                }
            }),
        }),
    }),
});

export const {
    useCreateNewMembershipMutation
} = membershipApiSlice;